import { createTheme } from "@mui/material/styles";
import { OptumDefault } from "@uhg-skyline/themes";

/**
 * Custom theme that extends Skyline's OptumDefault theme
 * Use this to override default styles for dialogs, buttons, and other MUI components site-wide
 */
export const customTheme = createTheme(OptumDefault, {
  components: {
    // Button overrides
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'EnterpriseSansVF',
          fontSize: '1rem',
          fontWeight: 600,
          padding: '10px 24px',
          borderRadius: '4px',
          textTransform: 'none',
        },
        containedPrimary: {
          backgroundColor: '#3D3C38',
          '&:hover': {
            backgroundColor: '#232220',
          },
        },
        outlinedPrimary: {
          backgroundColor: 'white',
          border: '1px solid #3D3C38',
          color: '#3D3C38',
          '&:hover': {
            backgroundColor: '#F3F3F3',
          },
        },
        text: {
          // Override text button styles
        },
      },
      defaultProps: {
        // Set default props for all buttons
        // Example: disableElevation: true,
      },
    },

    // Dialog overrides
    MuiDialog: {
      styleOverrides: {
        paper: {
          padding: '32px !important',
          // Style IconButtons inside dialogs (close buttons)
          '& .MuiIconButton-root': {
            position: 'absolute',
            right: '32px',
            top: '32px',
            color: '#3D3C38',
            padding: 0,
            '& .MuiSvgIcon-root': {
              width: '24px',
              height: '24px',
            },
          },
        },
        root: {
          // Override dialog root styles
        },
      },
      defaultProps: {
        // Set default props for all dialogs
        // Example: maxWidth: 'sm',
      },
    },

    // DialogTitle overrides
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },

    // DialogContent overrides
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },

    // DialogActions overrides
    MuiDialogActions: {
      styleOverrides: {
        root: {
          gap: '16px',
          padding: 0,
          margin: 0,
        },
      },
    },

    // Disable ripple globally for all ButtonBase-derived components
    // (Button, ListItemButton, AccordionSummary, IconButton, etc.)
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },

    // AccordionSummary overrides
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          "&.Mui-expanded": {
            minHeight: "var(--nav-accordion-summary-min-height, 48px)",
          },
        },
      },
    },

    // Add more component overrides as needed
    // MuiTextField: {},
    // MuiSelect: {},
    // MuiCard: {},
    // etc.
  },
});
